/**
 * A template's questions, answered Yes, No or Does not apply: on the start
 * screens, in the preview, and when work moves to a version that asks a new
 * one. Nothing is chosen until somebody chooses it on the start screens,
 * because a question left on a default would drop or keep a card nobody
 * meant to (decisions.md).
 */

import { ANSWERS, answerText, type Answer, type Question } from "@utuwrk/core";
import { Segmented } from "@vcnet/ui";

export function Questions({
  questions,
  answers,
  onChange,
}: {
  questions: readonly Question[];
  answers: Record<string, Answer | undefined>;
  onChange: (key: string, answer: Answer) => void;
}) {
  if (questions.length === 0) return null;
  return (
    <fieldset className="questions">
      <legend>About this person</legend>
      {questions.map((question) => (
        <div key={question.key} className="question">
          <p className="question-text">{question.text}</p>
          {question.help ? <p className="question-help">{question.help}</p> : null}
          <Segmented<Answer>
            label={question.text}
            size="sm"
            // Nothing pressed until somebody answers.
            value={(answers[question.key] ?? "") as Answer}
            options={ANSWERS.map((answer) => ({ value: answer, label: answerText(answer) }))}
            onChange={(answer) => onChange(question.key, answer)}
          />
        </div>
      ))}
    </fieldset>
  );
}
